import React from "react";
import { connect } from "react-redux";
import { Form, actions, Errors } from "react-redux-form";
import { Grid, Row, Col } from "react-bootstrap";
import ErrorMessages from "../login/error-messages";
import PageTitle from "../common/page-title";
import ArrowButton from "../common/button-arrow";
import RequiredInput from "../common/form/elements/required-input";
import { validateRegistrationAccountManager } from "../../actions/account-managers";

import "./styles.css";

class AccountManagerValidationForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.pageSlug = "account-manager-validation";
    this.state = {};
  }

  componentDidMount() {
    this.props.dispatch({ type: "START_ACCOUNT_MANAGER_REGISTRATION" });
  }

  handleSubmit = (payload) => {
    this.props.dispatch(
      actions.submit(
        "deep.registration.account_manager_validation",
        validateRegistrationAccountManager(payload)
      )
    );
  };

  render() {
    return (
      <Grid className="registration">
        <Row>
          <Col lg={12}>
            <PageTitle>Register</PageTitle>
          </Col>
        </Row>

        <Col xs={12} md={6}>
          <Form
            model="deep.registration.account_manager_validation"
            onSubmit={this.handleSubmit}
          >
            <Errors
              className="errors"
              model="deep.registration.account_manager_validation"
              component={ErrorMessages}
            />

            <RequiredInput
              model=".ho_number"
              controlId="ho_number"
              label="Head office Number"
              tooltip="If you don't know your Head Office Number please contact the Key Account Team"
            />

            <RequiredInput
              model=".email"
              controlId="email"
              label="Email"
              inputType="email"
            />

            <ArrowButton color="red" className="pull-right" arrow={false}>
              Next
            </ArrowButton>
          </Form>
        </Col>
      </Grid>
    );
  }
}

export default connect()(AccountManagerValidationForm);



// WEBPACK FOOTER //
// ./src/components/account-manager-validation/account-manager-validation-form.jsx